module.exports = __webpack_public_path__ + "static/media/Location Information.481d2d94.png";